var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.5L30.8803 27.5251C30.7219 30.0864 30.6428 31.3671 30.0008 32.2879C29.6833 32.7431 29.2747 33.1273 28.8007 33.416C27.8421 34 26.559 34 23.9927 34C21.4231 34 20.1383 34 19.179 33.4149C18.7048 33.1257 18.296 32.7408 17.9787 32.2848C17.3369 31.3626 17.2594 30.0801 17.1046 27.5152L16.5 17.5M15 17.5H33M28.0557 17.5L27.3731 16.0917C26.9196 15.1563 26.6928 14.6885 26.3017 14.3968C26.215 14.3321 26.1231 14.2745 26.027 14.2247C25.5939 14 25.0741 14 24.0345 14C22.9688 14 22.436 14 21.9957 14.2341C21.8981 14.286 21.805 14.3459 21.7173 14.4132C21.3216 14.7167 21.1006 15.2015 20.6586 16.1713L20.0529 17.5M21.5 28.5V22.5M26.5 28.5V22.5",
    stroke: "#F14336",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRecording);
export default __webpack_public_path__ + "static/media/Delete-recording.b283f20d0624b0e86e27ae0399be8d53.svg";
export { ForwardRef as ReactComponent };